import plusApi from '../../../api/plus/plus.js'

const state = {
    plus_info: {},
}
const getters = {}

const mutations = {
    get_plus_info(state, plus_info) {
        state.plus_info = plus_info
    },
}

const actions = {
    get_plus_info(context, plusId) {
        plusApi.get_plus_info(plusId).then(function (plus_info) {
            context.commit('get_plus_info', plus_info.data)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
